import { ContentContainer } from "containers";
import { MainContainer } from "./components";

const Cabinet = () => {
  return (
    <ContentContainer>
      <MainContainer />
    </ContentContainer>
  );
};

export default Cabinet;
